import React from 'react';
import { Button, Card } from 'antd';
// import { useSelector } from 'react-redux';
import { LeftOutlined } from '@ant-design/icons';
import SettingsForm from '../../components/Form/SettingsForm';
import Main from '../../components/layout/Main';
import BreadcrumbNav from '../../components/layout/BreadcrumbNav';
import Logout from '../../components/Logout';

import './profileSettings.scss';

const ProfileSettings = () => {
    const toolbar = [{ label: 'Item 1', link: '/abc', iconName: 'home' }];
    const navigation = [{ label: 'Item 1', link: '/abc' }, { label: 'Item 1', link: '/abc' }];

    const backLink = (
        <Button onClick={() => console.log('Back')}>
            <LeftOutlined /> BACK
        </Button>
    );

    return (
        <Main
            className="login"
            title={<div>Profilio nustatymai</div>}
            headerTitle={<div>Profilio nustatymai</div>}
            menuWidth={350}
            menuPlacement="left"
            toolbar={toolbar}
            showFooter={false}
            floatingHeader={false}
            footerContent={<div />}
            floatingFooter
            backLink={false}
            breadcrumb={null}>
            <Card style={{ marginTop: '20px' }}>
                <SettingsForm />
            </Card>
        </Main>
    );
};

export default ProfileSettings;

ProfileSettings.propTypes = {};
